<template>
  <v-btn color="primary" @click="download"> CSVとしてダウンロード </v-btn>
</template>

<script>
import blobDownloader from '@/mixins/blob_downloader'
import axios from 'axios'
import Qs from 'qs'

export default {
  name: 'CsvDownloadContainer',
  mixins: [blobDownloader],
  props: {
    query: {
      type: Object,
      default: () => ({
        master_access_not_eq: 0,
        master_access_eq: null,
        name_cont: '',
        email_cont: ''
      })
    }
  },
  methods: {
    download () {
      const query = this.query
      axios
        .get(`/api/master/user_auths/csv_downloads`, {
          responseType: 'blob',
          params: { file_type: 'ja', q: query },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(
          (response) => {
            this.downloadBlob(response)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.messages
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    }
  }
}
</script>
